import React from 'react'
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table'
import {IconButton, FloatingActionButton, FlatButton, TextField, DatePicker} from 'material-ui'
import ContentAdd from 'material-ui/svg-icons/content/add'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import EditorModeEdit from 'material-ui/svg-icons/editor/mode-edit'
import EditorAttachFile from 'material-ui/svg-icons/editor/attach-file'
import {FloatingButtonContainer, Form, FormRow, FormField, FormTitle} from './StyledComponents'
import {Link} from 'react-router-dom'
import {hasTokenFromLocalStorage} from './../helpers/token'
import {HOME} from '../routes'
import {ADD_PROCUREMENT_DIALOG, EDIT_PROCUREMENT_DIALOG, DELETE_PROCUREMENT_DIALOG} from '../routes'
import moment from 'moment'
import MyAppBarContainer from '../containers/MyAppBarContainer'

class ManageProcurement extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			begin: 0,
			end: 10,
			text: '',
			from: null,
			to: null
		};
	}

	handleSearchChange = (event, value) => {
		this.setState({
			text: value
		});
	};
	
	handleFromChange = (unknown, date) => {
		this.setState({
			from: date
		});
	};

	handleToChange = (unknown, date) => {
		this.setState({
			to: date
		});
	};

	componentDidMount()	{
		this.props.fetchProcurements();
	}


	render() {
		const { history, procurements } = this.props;
		if(hasTokenFromLocalStorage() === false) {
			history.push(HOME)
		}
		const filteredProcurements = procurements.filter((p) => {
			let isWithIn = true;
			if(this.state.from != null && this.state.to != null) {
				isWithIn = moment(p.date).isBetween(this.state.from, this.state.to, null, '[]')
			}
			if(p.project.toLowerCase().includes(this.state.text.toLowerCase()) && isWithIn) {
				return true
			}
			return false
		})
		const someProcurements = filteredProcurements.slice(this.state.begin, this.state.end);
		const AttachFileButton = ({procurement}) => {
			if(procurement.url === "") {
				return <IconButton style={{opacity: 0.5}} 
					target="_blank" 
					href={'http://wmsu.edu.ph/bac/'+moment(procurement.date).year()+'/'+procurement.type+'/'+procurement.project+'.pdf'}
					><EditorAttachFile /></IconButton>
			}
			else {
				return <IconButton style={{opacity: 0.5}} target="_blank" href={procurement.url}
					><EditorAttachFile /></IconButton>
			}
		}
		return(
			<div>
			<MyAppBarContainer/>
			<Form>
				<FormTitle>Filters</FormTitle>
				<FormRow>
					<FormField>
						<TextField 
							floatingLabelFixed={true}
							floatingLabelText="Search"
							hintText="Search Procurement"
							onChange={this.handleSearchChange}
							value={this.state.text}
						/>
					</FormField>
					<FormField>
						<DatePicker
							floatingLabelFixed={true}
							floatingLabelText="From"
							onChange={this.handleFromChange}
							value={this.state.from}
						/>
					</FormField>
					<FormField>
						<DatePicker
							floatingLabelFixed={true}
							floatingLabelText="To"
							onChange={this.handleToChange}
							value={this.state.to}
						/>
					</FormField>
				</FormRow>
			</Form>
			<Table style={{marginTop: "8px"}}>
				<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
				<TableRow>
					<TableHeaderColumn style={{width: "30%"}}>Project</TableHeaderColumn>
					<TableHeaderColumn>PR Number</TableHeaderColumn>
					<TableHeaderColumn>Category</TableHeaderColumn>
					<TableHeaderColumn>Date</TableHeaderColumn>
					<TableHeaderColumn>Post Until</TableHeaderColumn>
					<TableHeaderColumn>Actions</TableHeaderColumn>
				</TableRow>
				</TableHeader>
				<TableBody displayRowCheckbox={false}>
				{
					someProcurements.map((procurement, key) => (
						<TableRow key={key}>
							<TableRowColumn style={{width: "30%"}}>{procurement.project}</TableRowColumn>
							<TableRowColumn>{procurement.pr_num}</TableRowColumn>
							<TableRowColumn>{procurement.category}</TableRowColumn>
							<TableRowColumn>{moment(procurement.date).format('MMM DD, YYYY')}</TableRowColumn>
							<TableRowColumn>{moment(procurement.post_until).format('MMM DD, YYYY')}</TableRowColumn>
							<TableRowColumn>
								<IconButton style={{opacity: 0.5}}
									containerElement={<Link to={EDIT_PROCUREMENT_DIALOG+procurement.id}/>}
								><EditorModeEdit /></IconButton>
								<IconButton style={{opacity: 0.5}}
									containerElement={<Link to={DELETE_PROCUREMENT_DIALOG+procurement.id}/>}
								><ActionDelete /></IconButton>
								<AttachFileButton procurement={procurement}/>
							</TableRowColumn>
						</TableRow>
					))
				}
				</TableBody>
			</Table>
			<FlatButton 
					label="Load more" 
					primary={true} 
					fullWidth={true}
					onTouchTap={() => {
						this.setState((prevState, props) => {
							const num = 10;
							return { 
								end: prevState.end + num
							}
						})
					}}
			/>
			<FloatingButtonContainer>
				<FloatingActionButton secondary={true} onTouchTap={() => {
						history.push(ADD_PROCUREMENT_DIALOG)
					}}>
					<ContentAdd />
				</FloatingActionButton>
			</FloatingButtonContainer>
			</div>
		)
	}
}

export default ManageProcurement


// WEBPACK FOOTER //
// ./src/components/ManageProcurement.js